import { render, staticRenderFns } from "./LowIntentionStudent.vue?vue&type=template&id=656171ea&"
import script from "./LowIntentionStudent.vue?vue&type=script&lang=js&"
export * from "./LowIntentionStudent.vue?vue&type=script&lang=js&"
import style0 from "./LowIntentionStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports